import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  alertOnPreviewBtnClick() {
    const alertText = 'This is not a real button, it is part of the example Slack user notification message. When your users click Check Again, Kolide will recheck the device in real-time and tell your users whether or not the issue has been resolved. When your users click Contact Admin, Kolide will send a notification to your specified Slack escalation channel.';

    alert(alertText);
  }
}
